import OrderTemplate from './OrderTemplate';
import OrderImport from './OrderImport';

export {
  OrderTemplate,
  OrderImport
};



// WEBPACK FOOTER //
// ./src/components/common/OrderImport/index.js